let config = {
  firebaseConfig: {
    apiKey: "AIzaSyDfP0XCt3KrnuMtEvqGVlUtDu7ZyznV3nE",
    authDomain: "darchive5.firebaseapp.com",
    projectId: "darchive5",
    storageBucket: "darchive5.appspot.com",
    messagingSenderId: "401935292054",
    appId: "1:401935292054:web:d0efd92ecd1b06e634d4b7",
    measurementId: "G-TL4FJNPGS7",
  },
  ReCaptchaV3ProviderToken: "6LddAp8eAAAAAEv68MQ__zOT2OkpmlAY72696zeB",
  Web3StorageToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDg3RTZiZDFhYTUyOUNmYWRmOURhMGY0NTNiMEE4ZDlGRDM3MjM2ZUIiLCJpc3MiOiJ3ZWIzLXN0b3JhZ2UiLCJpYXQiOjE2NDU0NTQ1NTcyNjUsIm5hbWUiOiJEUGhvdG8ifQ.WM4zuZ9UuGwODetDm37xMmpPLkCXXai-wAxw9Opf7Yk",
};

export default config;
